/** @format */

import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL,
});

const handleRequest = async (method, url, data = null, token = null) => {
  try {
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await api.request({
      method,
      url,
      data,
      headers,
    });

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const getDataApi = async ({
  url,
  isPage,
  setPagination,
  filters,
  token,
}) => {
  let endPoint;

  if (isPage) {
    endPoint = `${url}?page=${isPage}`;
  } else {
    endPoint = `${url}`;
  }

  if (filters) {
    for (const key in filters) {
      if (key && filters[key]) {
        endPoint += `&${key}=${filters[key]}`;
      }
    }
  }

  try {
    const data = await handleRequest("get", endPoint, null, token);
    if (setPagination) setPagination(data?.pagination);
    return data;
  } catch (error) {
    throw new Error(
      `Error in GET request from ${endPoint} with message: ${error?.message}`
    );
  }
};

export const createApi = async ({ url, body, token }) => {
  try {
    const data = await handleRequest("post", url, body, token);
    return data;
  } catch (error) {
    throw new Error(
      `Error in POST request to ${url} with message: ${error?.message}`
    );
  }
};

export const getDataByIdApi = async (url, id = "4q60Mk7GJhyx9", filters) => {
  let endPoint = `${url}/${id}`;

  if (filters) {
    for (const filter in filters) {
      if (filter && filters[filter]) {
        endPoint += `&${filter}=${filters[filter]}`;
      }
    }
  }

  try {
    const data = await handleRequest("get", endPoint);

    if (!data.status) {
      throw new Error(`GET request failed with status ${data.status}`);
    }

    return data;
  } catch (error) {
    throw new Error(
      `Error in GET request from ${endPoint} with message: ${error?.message}`
    );
  }
};

export const updateApi = async (url, body) => {
  try {
    const data = await handleRequest("put", url, body);
    return data;
  } catch (error) {
    throw new Error(
      `Error in PUT request to ${url} with message: ${error?.message}`
    );
  }
};

export const updateApiFormData = async (url, form) => {
  try {
    const formData = new FormData();
    for (const key in form) {
      formData.append(key, form[key]);
    }

    const data = await handleRequest("put", url, formData);
    return data;
  } catch (error) {
    throw new Error(
      `Error in PUT request to ${url} with message: ${error?.message}`
    );
  }
};

export const deleteApi = async (url, uid) => {
  try {
    const data = await handleRequest("delete", `${url}?uid=${uid}`);
    return data;
  } catch (error) {
    throw new Error(
      `Error in DELETE request from ${url} with message: ${error?.message}`
    );
  }
};
